<template>
  <v-dialog
    :key="corporate.id"
    v-model="show"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-container>
        <v-card-title
          v-if="!corporate.id"
          class="headline px-0"
        >
          New Corporate
        </v-card-title>
        <v-card-text class="pa-3">
          <v-form
            id="form_register_corporate"
            ref="form"
            v-model="isValid"
            lazy-validation
          >
            <v-flex>
              <v-row wrap>
                <v-flex class="mb-3">
                  <strong class="form-title pb-3">Corporate Details</strong>
                  <v-text-field
                    id="corporate_name"
                    ref="acc_name"
                    v-model="corporate.name"
                    append-icon="mdi-hospitality-box"
                    name="account_Name"
                    :rules="nameRules"
                    label="Corporate Name*"
                    type="text"
                    autofocus
                    required
                    :error-messages="getError('Name')"
                    @mouseup="dirtyError('Name')"
                  />
                </v-flex>
              </v-row>
            </v-flex>
            <v-flex>
              <v-row>
                <v-flex xs12>
                  <strong class="form-title pb-3">Admin Employee Details</strong>
                  <v-text-field
                    id="register_firstName"
                    v-model="adminEmp.firstName"
                    append-icon="mdi-account"
                    name="firstName"
                    label="First Name*"
                    :rules="firstNameRules"
                    type="text "
                    required
                    :error-messages="getError('FirstName')"
                    @mouseup="dirtyError('FirstName')"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    id="register_lastName"
                    v-model="adminEmp.lastName"
                    append-icon="mdi-account"
                    name="lastName"
                    label="Last Name*"
                    :rules="lastNameRules"
                    type="text "
                    required
                    :error-messages="getError('LastName')"
                    @mouseup="dirtyError('LastName')"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    id="register_emailId"
                    v-model="adminEmp.emailID"
                    append-icon="mdi-mail"
                    name="emailId"
                    label="E-mailID*"
                    :rules="emailRules"
                    required
                    :error-messages="getError('EmailID')"
                    @mouseup="dirtyError('EmailID')"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    id="register_password"
                    v-model="adminEmp.password"
                    append-icon="mdi-lock"
                    name="password"
                    label="Password*"
                    :rules="passwordRules"
                    type="password"
                    required
                    hint="Password must be 6 to 12 characters"
                    :error-messages="getError('Password')"
                    @mouseup="dirtyError('Password')"
                  />
                </v-flex>
              </v-row>
            </v-flex>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div>
            <small style="font-weight:400;margin-right: 4px;">
              *indicates required field</small>
          </div>
          <v-spacer />
          <v-btn
            id="register_close"
            color="error"
            class="white--text"
            @click.native="close()"
          >
            Close
          </v-btn>
          <v-btn
            id="register_save"
            color="success"
            class="white--text"
            :disabled="!isValid "
            :loading="loader"
            @click.native="insert()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
	name: "CorporateRegister",
	props: {
		showDialog: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isValid: false,
			loader: false,
			corporate: {
				name: ""
			},
			errors: {},
			nameRules: [
				v => !!v || "First name is required",
				v =>
					(v && v.length <= 25) || "First name must be less than 25 characters"
			],
			firstNameRules: [
				v => !!v || "First name is required",
				v =>
					(v && v.length <= 25) || "First name must be less than 25 characters"
			],
			lastNameRules: [
				v => !!v || "Last name is required",
				v =>
					(v && v.length <= 25) || "Last name must be less than 25 characters"
			],
			passwordRules: [
				v => !!v || "Password is required",
				v =>
					(v && v.length >= 6 && v.length <= 12) ||
                    "Password must be 6 to 12 characters"
			],
			emailRules: [
				v => !!v || "E-mail is required",
				v =>
					/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/.test(
						v
					) || "E-mail must be valid"
			],
			adminEmp : {
				firstName: "",
				lastName: "",
				emailID: "",
				password :""
			}
		};
	},
	computed: {
		show() {
			return this.showDialog;
		}
	},
	methods: {
		close() {
			this.$emit("update:showDialog", false);
			this.$emit("refresh");
      this.clear();
		},
		insertCorporateAdmin(emp){
			console.log({emp});
			this.$http.post(`${this.ADMIN_API_URL}/corporate/employee`, emp).then(
				function (resp) {
					console.log("CORPORATE ADMIN INSERTED SUCCESSFULLY", {resp});
				},
				function (failure) {
					this.handleFailure(failure);
				}
			);
		},
		insert: function () {
			if (!this.$refs.form.validate()) {
				return;
			}
			this.loader = true;
			this.$http.post(`${this.ADMIN_API_URL}/corporates`, this.corporate).then(
				function (data) {
					this.loader = false;
					let corporate = data.body.data;
					this.adminEmp.corporateId = corporate.id;
					this.insertCorporateAdmin(this.adminEmp);
					this.close();
					this.$store.commit("showSnackbar", {
						timeout: 3000,
						message: data.body.message
					});
				},
				function (failure) {
					this.loader = false;
					this.handleFailure(failure);
				}
			);
		},
		getError(key) {
			return this.errors && this.errors[key] ? [this.errors[key]] : [];
		},
		dirtyError(key) {
			this.errors[key] = "";
		},
		handleFailure: function (failure) {
			let msg = failure.body.message || "Error";
			let errors = failure.body.errors;
			if (errors && errors.Name) {
				msg = errors.Name;
			}
			this.$store.commit("showSnackbar", {
				message: msg,
				color: "error"
			});
		},
		clear() {
			this.errors = {};
			this.$refs.form.reset();
		}
	}
};
</script>

<style>
.form-title {
	font-size: 16px;
	font-weight: 500 !important;
}
</style>